import { Injectable, TemplateRef } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material';
import { ComponentType } from '@angular/cdk/portal';

@Injectable({
  providedIn: 'root'
})
export class UnexpectedErrorMessageService {

  config: MatSnackBarConfig = {
    duration: 3000,
    horizontalPosition: 'end',
    verticalPosition: 'top',
  };

  constructor(private snackBar: MatSnackBar) { }

  open<T = any>(template: ComponentType<T> | TemplateRef<T>) {
    if (template instanceof TemplateRef) {
      this.openFromTemplate(template);
    } else {
      this.openFromComponent(template)
    }
  }

  openFromComponent<T>(component: ComponentType<T>) {
    this.snackBar.openFromComponent(component, this.config);
  }

  openFromTemplate<T = any>(templateRef: TemplateRef<T>) {
    this.snackBar.openFromTemplate(templateRef, this.config)
  }
}
